module.exports = "/build/web/svg/teams.79f622dbebff55c40be40f3fb495b8da.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/teams.svg
// module id = 231
// module chunks = 24